/**
 * Copyright (C) 2019 Olivier Parisot - All Rights Reserved.
 */

const percToColor = (perc) =>
{
    //value from 0 to 1
    const value=(100-perc)/100;
    const hue=((1-value)*120).toString(10);
    return ["hsl(",hue,",100%,50%)"].join("");
};

const stringToColor = (str) =>
  {
    var hash=0;
    for (var i=0;i<str.length;i++) 
    {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour='#';
    for (var j=0;j<3;j++) 
    {
      const value=(hash >> (j * 8)) & 0xFF;
      colour+=('00' + value.toString(16)).substr(-2);
    }
    return colour;
  };
  
module.exports = 
{ 
  percToColor: percToColor,
  stringToColor: stringToColor
}